import { type LargeIcon } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

export const isValidModule = (value: string | null | undefined): value is AvailableModules => {
  if (!value) return false
  const candidates = value
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
  return candidates.some(
    (candidate) =>
      Object.values(AvailableModules).some((enumValue) => enumValue === candidate) ||
      Object.values(Features).some((enumValue) => enumValue === candidate)
  )
}

const isValidIconType = (value: string | null | undefined): value is LargeIcon => {
  if (!value) return false
  return typeof value === 'string' && value.length > 0
}
